import React from 'react';
import { styled } from '@mui/material';

export const ErrorIcon = styled('img')(({ theme }) => ({
  // eslint-disable-line
  width: '20px',
  height: '20px',
}));

export const RemoveQuestionIcon = styled('img')(({ theme }) => ({
  // eslint-disable-line
  width: '20px',
  height: '20px',
}));
